export enum StudyRequestBehaviorEnum {
    None = '',
    Vivli = 'Vivli',
    External = 'External',
}
